export default __webpack_public_path__ + "/dist/images/social-icon.svg";